var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Update",
            id: "confirmSaveRoleModal",
            "ok-title": "Yes, Save"
          },
          on: { ok: _vm.saveRole },
          model: {
            value: _vm.showUpdateRole,
            callback: function($$v) {
              _vm.showUpdateRole = $$v
            },
            expression: "showUpdateRole"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Are you sure you want to save the changes made to this role?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.showConfirmModal)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [_vm._v("Role*")]),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: { mode: "passive", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.roleName,
                                              expression: "roleName"
                                            }
                                          ],
                                          ref: "focusThis",
                                          staticClass: "form-control",
                                          attrs: { type: "text" },
                                          domProps: { value: _vm.roleName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.roleName = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "validate-error text-danger"
                                          },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "submit", "data-dismiss": "modal" }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }